import _ from 'lodash';
import DataService from '../modules/assurance/services/data.service';
import DashboardService from '../modules/assurance/services/dashboard.service';

const DEFAULT_METADATA = [
];

function getMetadataById(fullMetadata, metadataId) {
  let metadata = _.find(fullMetadata, function(metadata) {
    return (metadata.id).toLowerCase() === metadataId.toLowerCase();
  });
  if (!metadata) {
    let defaultMetadata = _.find(DEFAULT_METADATA, function(metadata) {
      return (metadata.id).toLowerCase() === metadataId.toLowerCase();
    });
    if (defaultMetadata) {
      return defaultMetadata;
    }
    throw new Error('No metadata found for id \'' + metadataId + '\'');
  }
  return metadata;
}

const CPMA_FORMATTERS = {};

function convertType(type) {
  if (!type) return 'STRING';
  switch (type) {
    case 'numeric':
    case 'integer':
    case 'currency':
    case 'NUMBER':
      return 'NUMBER';
    case 'percentage':
    case 'PERCENTAGE':
      return 'PERCENTAGE';
    case 'datetime':
    case 'DATETIME':
      return 'none';
    case 'text':
    case 'tag': // TODO: this type applies to the Endpoint Tag column in the settings view. Is converting to "string" here safe?
    case 'string':
    case 'STRING':
      return 'STRING';
    default:
      return 'none';
  }
};

async function convertCpmaColumns(cpmaColumns, datasetName) {
  const metadata = await DataService.fetchAddCpmaDatasetMetadata();
  let convertedColumns = [];
  cpmaColumns.forEach(column => {
    let item = {
      id: column.columnKey,
      name: column.columnDescription,
      type: convertType(column.datatype),
      format: CPMA_FORMATTERS[column.datatype],
      description: column.columnLongDescription,
      // invisible: !column.uicolumn,
      // hidden: column.defaultFlag
      seq: column.columnSeq ? parseInt(column.columnSeq) : 999,
    };
    updateCpmaColMetadata(metadata, item.id, item, datasetName); // todo this should be better
    if (column.defaultFlag !== undefined && column.defaultFlag === 0) {
      item.notShown = true; // hidden or invisible?
    }
    convertedColumns.push(item);
  });
  return _.sortBy(convertedColumns, ['seq']); // todo clean this up
}

function getColumnKeyPrefix(columnKey) {
  if(_.startsWith(columnKey, 'query.') || _.startsWith(columnKey, 'query2')) { //UI-1214
    return columnKey;
  }
  return _.isString(columnKey) ? columnKey.split('.')[0] : '';
}

function updateCpmaColMetadata(metadata, id, item, datasetName) {
  if (metadata && metadata[id]) {
    Object.assign(item, metadata[id]);
    if (id === 'dimsystem.systemname') { // needs a dynamic api depending on which thing it's for
      let prefix = (datasetName || getColumnKeyPrefix(item.factKey) || item.datsetKey || '').toLowerCase();
      if (prefix === 'fctmeeting' || prefix === 'meeting' || prefix === 'meetingxml') {
        item.knownValuePath += '/meeting';
      } else if (prefix === 'fctschedulemeeting' || prefix === 'vmrxml') {
        item.knownValuePath += '/vmr';
      } else if (prefix === 'fctparticipant' || prefix === 'participantxml') {
        item.knownValuePath += '/participant';
      } else if (prefix === 'fctuser' || prefix === 'userxml') {
        item.knownValuePath += '/user';
      } else if (prefix === 'fctcapacity') {
        item.knownValuePath += '/capacity';
      } else if (prefix === 'fctcapacitydetail') {
        item.knownValuePath += '/capacitydetail';
      } else if (prefix === 'fctcapacityparticipant') {
        item.knownValuePath += '/capacityparticipant';
      // } else {
        // session
        // console.log('prefix', prefix);
      }

      if (item.field === 'dimsystem.systemname' && item.fieldText === 'System Name') {
        item.field = 'dimsystem.dimsystemsid';
        item.displayField = 'dimsystem.systemname';
        item.fieldText = 'System';
      } else if (item.columnKey === 'dimsystem.systemname' && item.columnDescription === 'System Name') {
        item.columnKey = 'dimsystem.dimsystemsid';
        item.displayField = 'dimsystem.systemname';
        item.columnDescription = 'System';
      } else if (item.id === 'dimsystem.systemname' && item.name === 'System Name') {
        item.id = 'dimsystem.dimsystemsid';
        item.displayField = 'dimsystem.systemname';
        item.name = 'System';
      }

    }
  }
}

export default {
  // With UI-2299 we updated the structure of datasets_metadata.json to include "categories" for some datasets.
  // This method returns the metadata in its original, pre-update structure
  fetchDatasetMetadataWithoutCategories: function(datasetName) {
    let self = this;
    return DataService.fetchDatasetMetadata().then(responseMetadata => {
      if (datasetName) {
        return this.fetchDatasetMetadataForCpmmOrCpma(responseMetadata, datasetName);
      }

      return responseMetadata;
    });
  },

  fetchDatasetMetadata: function(datasetName) {
    return DataService.fetchDatasetMetadata().then(responseMetadata => {
      if (datasetName) {
        return this.fetchDatasetMetadataForCpmmOrCpma(responseMetadata, datasetName);
      }

      return responseMetadata;
    });
  },

  fetchDatasetMetadataForCpmmOrCpma: async function(responseMetadata, datasetName) {
    let datasetMetadata;
    try {
      datasetMetadata = getMetadataById(responseMetadata, datasetName);
    } catch (e) {
      // no matching cpmm dataset, try cpma
      datasetMetadata = {
        id: datasetName,
        // columns: convertCpmaColumns(await DashboardService.fetchFilters({datasetName: datasetName})),
        columns: await convertCpmaColumns(await DashboardService.fetchDatasetColumnsMetadata(datasetName), datasetName), // todo split filter metadata call out or merge
        name: datasetName,
      };
    }
    return datasetMetadata;
  },

  fetchDataSourcesMetadata: function() {
    return DataService.fetchDataSourcesMetadata();
  },


// todo this is ugly needing to pass in metadata
  updateCpmaColMetadata: function(metadata, id, item, datasetName) {
    updateCpmaColMetadata(metadata, id, item, datasetName);
  }

}
